import * as variables from 'variables';

export default function setupGetParameters() {
	const prmstr = window.location.search.substr(1);
	const prmarr = prmstr.split('&');
	const prmarrLen = prmarr.length;
	let tmparr;
	let i;
	for (i = 0; i < prmarrLen; i += 1) {
		tmparr = prmarr[i].split('=');
		variables._GetParams[tmparr[0]] = tmparr[1];
	}
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/setupGetParameters.js
 **/